import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import Slide from "@mui/material/Slide";
import React from "react";

const Container = styled( Box )( () => ( {
	top: 0, right: 0, left: 0, bottom: 0,
	backgroundColor: "inherit",
	position: "absolute",
	padding: "0rem",
	height: "fit-content",
	borderRadius: "10px"
} ) );

interface IClientDetail {
	show: boolean;
	children: React.ReactElement<any, any>;
	direction: 'left' | 'right' | 'up' | 'down';
	sx?: React.CSSProperties;
}

export default function InnerContainer ( { show, children, sx = {}, direction = 'left' }: IClientDetail ) {

	return <>
		<Slide direction={ direction } in={ show } mountOnEnter unmountOnExit>
			<Container sx={ { ...sx } }>
				{ children }
			</Container>
		</Slide>
	</>
}